// extVersions.actions.js
import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const setExtVersion = (payload) => ({
  type: actionTypes.SET_EXT_VERSION,
  payload
});

export const resetExtVersion = () => ({
  type: actionTypes.RESET_EXT_VERSION,
});

export const getExtVersions = (params) => ({
  type: actionTypes.GET_EXT_VERSIONS,
  params
});

export const getExtVersion = (id) => ({
  type: actionTypes.GET_EXT_VERSION,
  id
});

export const createExtVersion = (payload) => ({
  type: actionTypes.CREATE_EXT_VERSION,
  payload
});

export const retryOutput = (id) => ({
  type: actionTypes.RETRY_EXT_VERSION_OUTPUT,
  id
});

export const updateExtVersion = (payload) => ({
  type: actionTypes.UPDATE_EXT_VERSION,
  payload,
});

export const deleteExtVersion = (Id) => ({
  type: actionTypes.DELETE_EXT_VERSION,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});


export const setOpenModal = (isOpen) => ({
  type: actionTypes.SET_OPEN_MODAL,
  payload: isOpen,
});

export const updateExtVersionsOrder = (orderData) => ({
    type: actionTypes.UPDATE_EXT_VERSIONS_ORDER,
    payload: { orderData }
});

export const getExtVersionFromKey = (payload) => ({
  type: actionTypes.GET_EXT_VERSION_BY_KEY,
  payload
});

export const downloadExtVersionCSV = (Key) => ({
  type: actionTypes.DOWNLOAD_EXT_VERSION_CSV,
  Key
});

export const startPolling = (versionId) => ({
    type: actionTypes.START_POLLING_EXT_VERSION_OUTPUT,
    payload: { versionId }
});

export const batchStatusCheck = (extId) => ({
    type: actionTypes.BATCH_STATUS_CHECK,
    extId,
});

export const initiateDraftSession = (payload) => ({
  type: actionTypes.INITIATE_DRAFT_SESSION,
  payload
});

export const recalculateExtVersion = (payload) => ({
  type: actionTypes.RECALCULATE_EXT_VERSION,
  payload
});
